<template>
  <div>
    <div
      ref="ad"
      class="ad ads Ad Ads googleAd googleAds"
    />
    <div
      v-if="isAdBlock"
      class="ad-modal-screen"
    >
      <div class="ad-modal-body text-center col-10 col-md-6 col-lg-3">
        <FontAwesomeIcon
          icon="sad-tear"
          size="4x"
          class="warn-color"
        />
        <div>
          <h3 class="mt-4 warn-color">
            AdBlock detected
          </h3>
          <p class="mt-4">
            <strong>
              In order to view this page content, please disable your AdBlock.
            </strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  div.ad {
    width: 1px;
    height: 1px;
    visibility: hidden;
  }
  div.ad-modal-screen {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    background-color: rgba(0,0,0,0.4);
    width: 100%;
    position: absolute;
    top: 0;
    height: 100%;
    overflow: hidden;
  }
  div.ad-modal-body {
    background-color: #ffff;
    border-radius: 1rem;
    padding: 2rem;
  }
  .warn-color {
    color: #EB5757;
  }
</style>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSadTear } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faSadTear);

export default {
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      routeSet: new Set(['/refer-a-friend/']),
      // special cases exist in which adblock will be present but some content may be included
      // if one of the elements with this id are present on the page than the content is included
      expectedIdArr: ['fbuy_iFrameResizer'],
      isMounted: false,
      isUsed: false,
    };
  },
  computed: {
    isAdBlock() {
      if (this.isUsed && this.isMounted) {
        const ele = this.$refs.ad;
        if (ele && ele.offsetWidth > 0) {
          document.body.style.overflow = 'auto';
          return false;
        }
        document.body.style.overflow = 'hidden';
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.isMounted = true;
    setTimeout(() => {
      // returns true when one of the expected eles appears on the page and breaks out of loop
      const isContent = this.expectedIdArr.some((id) => document.getElementById(id) != null);
      this.isUsed = this.routeSet.has(window.location.pathname) && !isContent;
    }, 2000);
  },
};
</script>
